import React from 'react'
import {
    Input,
    Button,
    Checkbox,
    FormItem,
    FormContainer,
    Alert,
} from 'components/ui'
import { PasswordInput, ActionLink } from 'components/shared'
import useTimeOutMessage from 'utils/hooks/useTimeOutMessage'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import useAuth from 'utils/hooks/useAuth'
import CryptoJS from "crypto-js";
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import useQuery from 'utils/hooks/useQuery'
import { GoogleOAuthProvider,GoogleLogin,useGoogleLogin } from '@react-oauth/google';
import axios from 'axios'
import GoogleBtn from '../GoogleBtn'
import ReactGA from 'react-ga4';
const validationSchema = Yup.object().shape({
    email: Yup.string().required('Please enter your user name'),
    password: Yup.string().required('Please enter your password'),
    rememberMe: Yup.bool(),
})

const SignInForm = (props) => {
    
    const query = useQuery()
    const redirectUrl = query.get(REDIRECT_URL_KEY)
    const {
        disableSubmit = false,
        className,
        forgotPasswordUrl = '/forgot-password',
        signUpUrl = '/sign-up?redirectUrl='+redirectUrl,
    } = props

    const [message, setMessage] = useTimeOutMessage()

    const { signIn,createGuestSession,externalAuth } = useAuth()

    const onSignIn = async (values, setSubmitting) => {
        ReactGA.event({
            category: "Auth",
            action: "Sign in",
            label: "App Auth", // optional
            
          });
        const { email, password } = values;
        const encryptedPassword = CryptoJS.AES.encrypt(password, process.env.REACT_APP_SECRET).toString();
        const encpass =  CryptoJS.AES.encrypt(encryptedPassword, process.env.REACT_APP_SECRET_ADDON).toString();
        setSubmitting(true)

        const result = await signIn({ email, encpass })

        if (result.status === 'failed') {
            setMessage(result.message)
        }

        setSubmitting(false)
    }
    const starteGuestOrder = async()=>{
        await createGuestSession()
    }
    const login = useGoogleLogin({
        
        onSuccess: (codeResponse) => {
            setMessage(null)
            axios
    .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${codeResponse.access_token}`, {
        headers: {
            Authorization: `Bearer ${codeResponse.access_token}`,
            Accept: 'application/json'
        }
    })
    .then((res) => {
        verifyExternalSource(res.data,codeResponse.access_token)
    })
    .catch((err) => console.log(err));
        },
        onError: (error) => setMessage('Login Failed, please try again')
    });
    const verifyExternalSource = async (data,access_token) =>{
        ReactGA.event({
            category: "Auth",
            action: "Sign in action",
            label: "App Auth Google", // optional
            
          });
        
        const result = await externalAuth({ ...data,source:"google",access_token:access_token })

        if (result.status === 'failed') {
            setMessage(result.message)
        }

        
    }
    return (
        <div className={className}>
            {message && (
                <Alert className="mb-4" type="danger" showIcon>
                    {message}
                </Alert>
            )}
            <div className="mt-4 mb-4 text-center">
<button onClick={login} className="gsi-material-button">
  <div className="gsi-material-button-state"></div>
  <div className="gsi-material-button-content-wrapper">
    <div className="gsi-material-button-icon">
      <GoogleBtn />
    </div>
    <span className="gsi-material-button-contents">Continue with Google</span>
    <span style={{display:"none"}}>Continue with Google</span>
  </div>
</button></div>
<div className='py-3 text-center'>or</div>
            <Formik
                // Remove this initial value
                initialValues={{
                    email: '',
                    password: '',
                    rememberMe: true,
                }}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting }) => {
                    if (!disableSubmit) {
                        onSignIn(values, setSubmitting)
                    } else {
                        setSubmitting(false)
                    }
                }}
            >
                {({ touched, errors, isSubmitting }) => (
                    <Form>
                        <FormContainer>
                            <FormItem
                                label="Email"
                                invalid={errors.userName && touched.userName}
                                errorMessage={errors.userName}
                            >
                                <Field
                                    type="text"
                                    autoComplete="off"
                                    name="email"
                                    placeholder="Email"
                                    component={Input}
                                />
                            </FormItem>
                            <FormItem
                                label="Password"
                                invalid={errors.password && touched.password}
                                errorMessage={errors.password}
                            >
                                <Field
                                    autoComplete="off"
                                    name="password"
                                    placeholder="Password"
                                    component={PasswordInput}
                                />
                            </FormItem>
                            <div className="flex justify-between mb-6">
                                <Field
                                    className="mb-0"
                                    name="rememberMe"
                                    component={Checkbox}
                                    children="Remember Me"
                                />
                                <ActionLink to={forgotPasswordUrl}>
                                    Forgot Password?
                                </ActionLink>
                            </div>
                            <Button
                                block
                                loading={isSubmitting}
                                variant="solid"
                                type="submit"
                            >
                                {isSubmitting ? 'Signing in...' : 'Sign In'}
                            </Button>
                            {/* <div className="mt-4 text-center">
                            <a  href='https://apps.shopify.com/us-print-factory'><Button
                                block
                                type="button"
                                variant="twoTone"
                    color="green-600"
                            >
                                Sign in with Shopify
                            </Button></a>
                            </div> */}
                            {/* <div className="mt-4 text-center">
                            <Button
                                block
                                type="button"
                                variant="solid"
                                color="purple-500"
                                onClick={starteGuestOrder}
                            >
                                Order as Guest
                            </Button>
                            </div> */}
                            <div className="mt-4 text-center">
                                <span>Don't have an account yet? </span>
                                <ActionLink to={signUpUrl}>Sign up</ActionLink>
                            </div>
                        </FormContainer>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default SignInForm
